import type { Levels } from './global-navigation'

export const LEVELS: Levels = {
  main: 1,
  second_level: 2,
  third_level: 3,
  fourth_level: 4,
  accordion: 'accordion',
}
